import {
  FETCH_USER_STATUS,
  FETCH_USER_REMIND,
  CANCEL_USER_REMIND,
  LOG_OUT,
  BIND_MOBILE,
} from '../constants';

function deleteByInx(array, inx) {
  const result = array.slice()
  result.splice(inx, 1)
  return result
}

export default function runtime(state = {
  status: {},
  remind: [],
}, action) {
  switch (action.type) {
    case FETCH_USER_STATUS:
      return {
        ...state,
        status: action.data,
      }
    case FETCH_USER_REMIND:
      return {
        ...state,
        remind: action.data.result,
      }
    case CANCEL_USER_REMIND:
      return {
        ...state,
        remind: deleteByInx(state.remind, action.inx),
      }
    case BIND_MOBILE:
      return {
        ...state,
        bindstatus: action.data,
      }
    case LOG_OUT:
      return {
        ...state,
        status: {},
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js